var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2237 1.60529L11.1768 1.65524L12.1195 1.80455L13.0414 2.05157L13.9325 2.39361L14.7829 2.82692L15.5834 3.34675L16.3251 3.9474L17 4.62229L17.6006 5.36403L18.1205 6.1645L18.5538 7.01491L18.8958 7.90596L19.1428 8.82788L19.2922 9.77057L19.3421 10.7237L19.2922 11.6768L19.1428 12.6195L18.8958 13.5415L18.5538 14.4325L18.1205 15.2829L17.6006 16.0834L17 16.8251L16.3251 17.5L15.5834 18.1007L14.7829 18.6205L13.9325 19.0538L13.0414 19.3958L12.1195 19.6429L11.1768 19.7922L10.2237 19.8421L9.27055 19.7922L8.32786 19.6429L7.40594 19.3958L6.51489 19.0538L5.66447 18.6205L4.86401 18.1007L4.12227 17.5L3.44738 16.8251L2.84673 16.0834L2.3269 15.2829L1.89359 14.4325L1.55155 13.5415L1.30452 12.6195L1.15521 11.6768L1.10526 10.7237L1.15521 9.77057L1.30452 8.82788L1.55155 7.90596L1.89359 7.01491L2.3269 6.1645L2.84673 5.36403L3.44738 4.62229L4.12227 3.9474L4.86401 3.34675L5.66447 2.82692L6.51489 2.39361L7.40594 2.05157L8.32786 1.80455L9.27055 1.65524L10.2237 1.60529Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4109 8.23682L8.30275 14.345L5.52631 11.5685",
    stroke: "#D20E50",
    strokeWidth: 1.66015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.88a814d2.svg";
export { ForwardRef as ReactComponent };